import * as _actions from './actions';
import _reducer from './reducer';
import _CourseEvent from './model';

export const actions = _actions;
export const reducer = _reducer;
export const CourseEvent = _CourseEvent;



// WEBPACK FOOTER //
// ./data/CourseProgress/index.js